export const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_FAILED = 'GET_SERVICES_FAILED';

export const CANCEL_SERVICE = 'CANCEL_SERVICE';
export const CANCEL_SERVICE_SUCCESS = 'CANCEL_SERVICE_SUCCESS';
export const CANCEL_SERVICE_FAILED = 'CANCEL_SERVICE_FAILED';
